import React, { Dispatch, SetStateAction } from 'react';
import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector as useReduxSelector,
} from 'react-redux';

import { Box, Button, Drawer, styled, Typography } from '@mui/material';

import { RootState } from '../../../../app/rootReducer';
import { AppDispatch } from '../../../../app/store';
import { Resource } from '../../../../common/constants/resource';
import { initiateReinstatement } from '../../detailSlice';
import styles from '../styles.module.scss';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export const ReviewReinstatementDrawer = ({
  applicationId,
  isOpen,
  setIsOpen,
}: {
  applicationId: number;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <Drawer
      open={isOpen}
      anchor="right"
      variant="persistent"
      classes={{ paper: styles.Drawer }}
      transitionDuration={{ enter: 0, exit: 0 }}
    >
      <Box mt={6}>
        <Box
          m={3}
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body1">
            {Resource.INITIATE_REINSTATEMENT}
          </Typography>
          <Button onClick={() => setIsOpen(false)}>
            <Typography variant="subtitle2" color="textSecondary">
              Close
            </Typography>
          </Button>
        </Box>
        <FixedButtonWrapper>
          <FixedButton
            variant="contained"
            color="primary"
            disableElevation
            onClick={() => {
              dispatch(initiateReinstatement(applicationId));
              setIsOpen(false);
            }}
          >
            {Resource.INITIATE_REINSTATEMENT}
          </FixedButton>
        </FixedButtonWrapper>
      </Box>
    </Drawer>
  );
};

const FixedButtonWrapper = styled(Box)(() => ({
  position: 'fixed',
  right: '24px',
  bottom: 0,
  zIndex: 4,
  width: 'calc(375px - 48px)',
}));

const FixedButton = styled(Button)(() => ({
  textTransform: 'none',
  height: '56px',
  marginBottom: '24px',
}));
